import { getPLPQueryFilters, type XgenPageData } from '@/utils/xgenPageLoad'

declare global {
  interface Window {
    pageData: XgenPageData | undefined
  }
}

/**
 * Global middleware for managing XgenPageData lifecycle on route changes.
 *
 * Client-side:
 * - on route changes: resets window.pageData to undefined
 * - on PLP pages where query params have changed: updates filters and fires event
 *
 * Note: The hooks (app:rendered and page:finish) are now handled in the xgenPageData plugin.
 * @see ./packages/global/plugins/xgenPageData.ts
 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.server) return

  // Reset page data on route change (takes into account query params and other route changes)
  const isTheSamePath = to.path === from.path

  if (!isTheSamePath) {
    Object.assign(window, {
      pageData: undefined,
    })
  } else if (window.pageData?.pageType === 'category') {
    // On PLP pages where query params, have changed, check if filters have been updated
    const filters = getPLPQueryFilters(to)
    if (
      JSON.stringify(filters) !==
      JSON.stringify(window.pageData.selectedFilters)
    ) {
      const pageDataWithFilters = {
        ...window.pageData,
        selectedFilters: filters,
      }

      Object.assign(window, { pageData: pageDataWithFilters })

      // Dispatch a custom event to let xGen know that page data has changed
      window.dispatchEvent(
        new CustomEvent('xgen-page-load', {
          detail: window.pageData,
        })
      )
    }
  }
})
